import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

/**
 * Supervisor: primera vez y cada ~3 meses debe completar la encuesta de manada (/profile-quiz).
 */
export default function SupervisorEntryGate({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div className="sup-loading">Cargando…</div>;
    }

    const onRegistroManada = location.pathname === '/profile-quiz';
    const needsManada = user?.needsRegistroManada === true;
    const encuestaRecienHecha = location.state?.encuestaCompletada === true;

    if (needsManada && !onRegistroManada && !encuestaRecienHecha) {
        return (
            <Navigate
                to="/profile-quiz"
                replace
                state={{ from: location.pathname, reason: 'registro_manada' }}
            />
        );
    }

    return children;
}
